<template>
  <div>
    <h1 class="title is-h1">Confirm Your Email Address</h1>
    <p>A verification code was sent to {{ email }}. Please enter the code below to confirm your email address.</p>

    <div class="notification is-danger" v-if="errorMessage">
      {{ errorMessage }}
    </div>

    <form @submit.prevent="handleConfirm">
      <b-field label="Confirmation Code">
        <b-input type="text" :required="true" v-model.trim="code"></b-input>
      </b-field>
      <button type="submit" class="button is-primary" :disabled="isLoading">Submit Code</button>
      <p>
        Can't find the email? <a @click="resendCode()">Click here to resend the code.</a>
      </p>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    email: String,
    sendCode: Boolean
  },
  data () {
    return {
      code: null,
      isResending: false,
      isLoading: false,
      errorMessage: null
    }
  },
  methods: {
    resendCode (supressNotification) {
      // avoid duplicate re-sends
      if (this.isResending) {
        return
      }
      // send
      this.isResending = true
      this.$cognito.cognitoResendConfirmationCode(this.email)
        .then((response) => {
          // Notify of the success
          if (!supressNotification) {
            this.$toast.open({
              message: 'New code has been emailed',
              type: 'is-success'
            })
          }
        })
        .catch((e) => {
          this.errorMessage = e.message
        })
        .finally(() => {
          this.isResending = false
        })
    },

    handleConfirm () {
      this.$cognito.cognitoConfirmRegistration(this.email, this.code)
        .then((response) => {
          // emit the confirmed action
          this.$emit('confirm', response)
        })
        .catch((e) => {
          this.errorMessage = e.message
        })
    }
  },
  created () {
    // send the confirmation code on creation, if it was requested
    if (this.sendCode) {
      this.resendCode(true)
    }
  }
}
</script>
